<template>
    <div class="row">
        <div class="col-md-6">
            <datepicker
                v-model="dateValue"
                :disabled="disabled"
                :hint="hint"
                :label="label"
                :placeholder="datePlaceholder"
            />
        </div>
        <div class="col-md-6">
            <timepicker
                v-model="timeValue"
                :disabled="disabled"
                :hint="hint"
                :label="label"
                :placeholder="timePlaceholder"

                align-right
                picker-family="widget-datetime">
            </timepicker>
        </div>
    </div>
</template>

<script>
import { dateISOToDateUS, dateTodayISO, dateUSToDateISO } from '../../../../../utils/date';

export default {
    props: {
        value: String,
        disabled: Boolean,
        label: String,
        hint: String,
        default: String,
    },
    computed: {
        dateValue: {
            get() {
                return dateISOToDateUS(this.value?.split('T')[0]);
            },
            set(val) {
                this.$emit('input', val ? `${dateUSToDateISO(val)}T${this.timeValue ?? '00:00'}` : null);
            }
        },
        timeValue: {
            get() {
                return this.value?.split('T')[1];
            },
            set(val) {
                this.$emit('input', `${dateUSToDateISO(this.dateValue) ?? dateTodayISO()}T${val ?? '00:00'}`);
            }
        },
        datePlaceholder() {
            return dateISOToDateUS(this.default?.split('T')[0]);
        },
        timePlaceholder() {
            return this.default?.split('T')[1];
        }
    }
};
</script>

